import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { OrderService } from "../../../order.service";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";

@Component({
  selector: "order-paymentlinkfastaccess",
  templateUrl: "./paymentlinkfastaccess.component.html",
  styleUrls: ["./paymentlinkfastaccess.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentLinkFastAccessComponent extends BaseFormComponent<any> {
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, public order: OrderService) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "";
    this.label = "";
    this.areaName = "";
    this.FillData();
  }
  FillData(): void {
    const controllers = {
      HasPaymentLink: new UntypedFormControl(!!this.order.invoice?.HasPaymentLink),
      HasFactorLink: new UntypedFormControl(!!this.order.invoice?.HasFactorLink),
    };
    this.formGroup = new UntypedFormGroup(controllers);
    if (this.order.invoice.Customer.AutomaticDebtor) {
      this.formGroup.controls["HasPaymentLink"].disable({ emitEvent: false });
      this.formGroup.controls["HasFactorLink"].disable({ emitEvent: false });
    }
  }

  addControl() {
    this.setValue("HasPaymentLink", this.model.ApplyTax);
    this.setValue("HasFactorLink", this.model.ApplyService);
  }

  public onPaymentLinkChanges(value: boolean): void {
    if (!this.order.common.smartConnection) {
      this.order.invoice.HasPaymentLink = false;
      this.setValue("HasPaymentLink", false);
      this.sts.showToast("danger", "", this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.PaymentLink.SmartConnectionFailed"));
      return;
    }
    this.order.invoice.HasPaymentLink = value;
    if (value) this.setValue("HasFactorLink", value);
  }
  public onFactorLinkChanges(value: boolean): void {
    if (!this.order.common.smartConnection) {
      this.order.invoice.HasFactorLink = false;
      this.setValue("HasFactorLink", false);
      this.sts.showToast("danger", "", this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.PaymentLink.SmartConnectionFailed"));
      return;
    }
    this.order.invoice.HasFactorLink = value;
    if (!value) this.setValue("HasPaymentLink", false);
  }
}
